const Footer = () => {
    return (
        <div className="absolute-center">@2022</div>
    )
}
export default Footer;